import { authContext, Profile } from '@staffedupusa/shared-components';
import { useContext } from 'react';

import { MILESTONES } from './constants';
import { Milestone } from '../types';

function useAccountCompletion(): Milestone[] {
  const { authData } = useContext(authContext);

  return MILESTONES.map((item) => {
    // maping subproperties
    if (item.subproperties) {
      item.subproperties = item.subproperties.map((subproperty) => {
        subproperty.complete =
          (authData.user &&
            !!authData.user[subproperty.completionProperty as keyof Profile]) ||
          false;

        return subproperty;
      });
    }

    return item;
  }).map((item) => {
    // maping completion
    item.complete =
      (authData.user &&
        !!authData.user[item.completionProperty as keyof Profile]) ||
      (item.subproperties &&
        item.subproperties.every((subproperty) => subproperty.complete)) ||
      false;

    return item;
  });
}

export default useAccountCompletion;
